import React from "react";
import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function Hero() {
  const control = useAnimation();
  const [ref, inView] = useInView();

  const variantBuild = (i) => {
    return {
      visible: {
        opacity: 1,
        y: 0,
        transition: { delay: 0.3 * i, duration: 1 },
      },
      hidden: { opacity: 0, y: 100 },
    };
  };

  React.useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);

  return (
    <section className="h-fit relative" id="home" ref={ref}>
      <img className="w-full h-full object-cover min-h-[400px]" src="images/BgHome.svg" alt="Home" />
      {/* <img className="object-contain h-140 w-140" src="images/BgHome.svg" alt="Home" /> */}
      <div className="bg-[#072E6F]/80 w-full lg:w-[950px] px-4 pb-12 absolute bottom-16 z-10">
        <motion.h1
          className="font-bold text-3xl sm:text-4xl max-w-[450px] break-words text-default mb-8 pt-8"
          animate={control}
          initial="hidden"
          variants={variantBuild(0)}
        >
          We provide tug and barge to carry bulk cargo.
        </motion.h1>
        <p className="font-bold text-lg sm:text-xl text-default italic pb-8">
          <motion.span ref={ref} animate={control} initial="hidden" variants={variantBuild(7)}>
            Safe{" "}
          </motion.span>
          <motion.span ref={ref} animate={control} initial="hidden" variants={variantBuild(8)}>
            and{" "}
          </motion.span>
          <motion.span ref={ref} animate={control} initial="hidden" variants={variantBuild(10)}>
            reliable
          </motion.span>
        </p>
      </div>
      {/* Buttons */}
      <div className="bg-[#114F94] relative -mt-36">
        <div className="flex justify-center gap-8 p-8 relative z-10">
          <motion.a
            className="bg-primary py-4 px-4 sm:px-8 text-sm sm:text-xl font-bold text-default rounded-lg whitespace-nowrap hover:bg-[#5EA2E6] duration-300 relative"
            href="#about-us"
            animate={control}
            initial="hidden"
            variants={variantBuild(1)}
          >
            Learn more about us
          </motion.a>
          <motion.a
            className="bg-primary py-4 px-4 sm:px-8 text-sm sm:text-xl font-bold text-default rounded-lg whitespace-nowrap hover:bg-[#5EA2E6] duration-300 relative"
            href="#contact-us"
            animate={control}
            initial="hidden"
            variants={variantBuild(2)}
          >
            Contact us now
          </motion.a>
        </div>
      </div>
    </section>
  );
}
